import { FilterColumn } from '@blisspointmedia/bpm-types/dist/FilterBar';

export const SIZE_ALERT_THRESHOLD = 0.95;

export const FILTER_OPTIONS: FilterColumn[] = [
  { label: 'Name', name: 'name' },
  { label: 'Lookback', name: 'lookback' },
  { label: 'Status', name: 'status' }
];
